<template>
    <div class="text-center" v-if="loading">
        <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">{{ $trans.get('__JSON__.Loading...') }}</span>
        </div>
    </div>

    <div v-else>
        <div v-for="(items, document) in uploads">
            <div class="d-flex align-items-center mt-2" v-for="(upload, field) in items">
                <div class="flex-auto">
                    <div class="icon icon-sm text-sm icon-shape" :class="`bg-soft-${upload.color} text-${upload.color}`">
                        <i :class="upload.icon"></i>
                    </div>
                </div>
                <div class="flex-fill ms-3">
                    <span class="d-block font-semibold text-sm">{{ upload.filename }}</span>
                    <span class="d-block text-xs text-muted">{{ document }}: {{ field }}</span>
                </div>
                <div class="text-end align-self-start">
                    <span class="font-semibold text-xs">{{ upload.size }}</span>
                    <ul class="d-block text-xs text-muted list-unstyled mb-0 pb-0">
                        <li class="list-inline-item" v-if="hasPreview(upload)">
                            <a href="#" @click="filePreview(upload)">
                                <i class="bi bi-cast"></i>
                            </a>
                        </li>
                        <li class="list-inline-item">
                            <a href="#" @click="fileDownload(upload)">
                                <i class="bi bi-cloud-download"></i>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="modal fade vh-100" id="previewModal" ref="previewModal">
            <div class="modal-dialog modal-lg" style="height: 90vh !important">
                <div class="modal-content" style="height: 90vh !important">
                    <div class="modal-header">
                        <h5 class="modal-title" id="previewModalLabel">
                            {{ $trans.get('__JSON__.Preview') }}
                            <br/><small class="text-muted">{{ preview.name }}</small>
                        </h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body vh-100" v-if="preview.type">
                        <img :src="preview.content" v-if="preview.type.includes('image')">
                        <object width="100%" height="100%" :data="preview.content" :type="preview.type" :name="preview.name" v-else-if="preview.type.includes('pdf')" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'UploadedFiles',
    props: {
        tags: {
            type: Array,
            required: true,
        },
        system: {
            type: Boolean,
            required: false,
            default: false,
        },
        user: {
            type: String,
            required: false,
            default: null,
        },
    },
    data() {
        return {
            loading: false,
            uploads: [],

            preview: {},
        }
    },
    methods: {
        retrieveUploads() {
            this.loading = true
            axios.post('/api/document/uploads', {
                tags: this.tags,
                system: this.system,
                user: this.user,
            })
                .then(response => this.uploads = response.data)
                .finally(() => this.loading = false)
        },
        hasPreview(file) {
            return ['image', 'pdf'].some(type => file.mime_type.includes(type))
        },
        filePreview(file) {
            if (! this.hasPreview(file)) return

            this.preview = {
                name: file.filename,
                type: file.mime_type,
                content: file.content,
            }

            const modalEl = this.$refs.previewModal
            modalEl.addEventListener('hide.bs.modal', () => {
                this.preview = {}
            })
            const modal = new bootstrap.Modal(modalEl)
            modal.show()
        },
        fileDownload(upload) {
            download(upload.content, upload.filename, upload.mime_type)
        },
        download(uri, data) {
            axios.post(uri, data, {
                responseType: 'blob',
            })
                .then(response => this.downloadResponse(response))
                .catch(error => this.error(error))
        },
        error(error) {
            console.error(error)
        },
    },
    mounted() {
        this.retrieveUploads()
    }
}
</script>
